import React, { useState } from 'react';
import styles from './DailyActivitiesSection.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import TabSelector from '../../components/TabSelector/TabSelector';
import DailyActivitiesCard from '../../components/DailyActivitiesCard/DailyActivitiesCard';
import { TbActivityHeartbeat } from 'react-icons/tb';
import DailyActivitiesphoto from '../../assets/images/Dailyactivityphoto.png';
import Dropdown from '../../components/Dropdown/Dropdown';

const DailyActivitiesSection = () => {
  const tabOptions = [{ label: 'Center' }, { label: 'Room' }];
  const [activeTab, setActiveTab] = useState(tabOptions[0].label);

  const activities = [
    { icon: DailyActivitiesphoto, label: 'Photos', count: 0 },
    { icon: DailyActivitiesphoto, label: 'Announcements', count: 0 },
    { icon: DailyActivitiesphoto, label: 'Videos', count: 0 },
    { icon: DailyActivitiesphoto, label: 'Photos', count: 0 },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<TbActivityHeartbeat className={styles.headingIcon} />}
          heading="Daily Activities"
        />

       
        <Dropdown label="Rooms" options={['Room A', 'Room B']} />
      </div>

      <div className={styles.cardContainer}>
        {activities.map((item, index) => (
          <DailyActivitiesCard
            key={index}
            icon={item.icon}
            label={item.label}
            count={item.count}
          />
        ))}
      </div>

      <div className={styles.totalRow}>
        <span>Total</span>
        <span>0</span>
      </div>
    </div>
  );
};

export default DailyActivitiesSection;
